import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "/brand/society-logo.png";

export default function Logo({ to = "/", size = "md", className = "" }) {
  const sizes = {
    sm: { mark: 32, text: "text-lg" },
    md: { mark: 44, text: "text-2xl" },
    lg: { mark: 80, text: "text-5xl" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <Link
      to={to}
      data-testid="logo-link"
      className={`inline-flex items-center gap-3 group ${className}`}
    >
      <span
        className="relative inline-flex items-center justify-center transition-transform duration-500 group-hover:rotate-[12deg]"
        style={{ width: s.mark, height: s.mark }}
      >
        {/* Glow pulse layer — sits behind the logo, doesn't use mix-blend-mode */}
        <span
          aria-hidden
          className="nav-logo-glow absolute inset-0 rounded-full pointer-events-none"
          style={{
            background:
              "radial-gradient(closest-side, rgba(185,164,255,0.85), rgba(243,168,92,0.55) 50%, transparent 75%)",
          }}
        />
        {/* The actual logo */}
        <img
          src={LOGO_URL}
          alt="Society"
          width={s.mark}
          height={s.mark}
          style={{ width: s.mark, height: s.mark, mixBlendMode: "screen" }}
          className="relative object-contain select-none"
          draggable={false}
        />
      </span>
      <span className={`font-elegant ${s.text} tracking-wide text-white/95 leading-none`}>
        Society
      </span>
    </Link>
  );
}
